import React, { useState } from 'react';
import { ArrowUpRight, X } from 'lucide-react';
import { MMSL_URL, REMOTEGIG_URL, withUtm } from '../../utils/sponsorLinks';

const DISMISS_KEY = 'topBannerDismissed';

const readDismissed = () => {
  try {
    return localStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
};

const pillClass =
  'group flex flex-shrink-0 items-center gap-2 rounded-full border border-gray-200 bg-white py-1 pl-1 pr-2.5 text-xs text-gray-600 sm:pr-3 sm:text-sm shadow-sm transition-colors hover:border-blue-300';

const TopBanner = () => {
  const [dismissed, setDismissed] = useState(readDismissed);

  if (dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // storage unavailable; dismissal lasts for this page view only
    }
  };

  return (
    <div className="relative w-full border-b border-gray-200 bg-blue-50 py-2 pl-3 pr-10 sm:px-10">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-2 sm:gap-3">
        <span className="hidden flex-shrink-0 whitespace-nowrap font-mono text-[11px] uppercase tracking-wider text-gray-500 2xl:inline">
          More from the founder
        </span>
        <a href={withUtm(MMSL_URL, 'top-bar')} target="_blank" rel="noopener noreferrer" className={pillClass}>
          <img src="/mmsl-icon.png" alt="" className="h-6 w-6 flex-shrink-0 rounded-full object-cover" />
          <span className="whitespace-nowrap font-semibold text-gray-900">MakeMySiteLive</span>
          <span className="hidden whitespace-nowrap xl:inline">Publish your website in under 2 minutes</span>
          <span className="hidden rounded bg-yellow-100 px-1.5 py-0.5 text-[11px] font-semibold text-yellow-800 xl:inline">New</span>
          <ArrowUpRight size={15} className="hidden flex-shrink-0 text-blue-600 sm:block" />
        </a>
        <a href={withUtm(REMOTEGIG_URL, 'top-bar')} target="_blank" rel="noopener noreferrer" className={pillClass}>
          <img src="/remotegig-icon.png" alt="" className="h-6 w-6 flex-shrink-0 rounded-full object-cover" />
          <span className="whitespace-nowrap font-semibold text-gray-900">RemoteGigs</span>
          <span className="hidden whitespace-nowrap xl:inline">Find remote jobs and gigs</span>
          <ArrowUpRight size={15} className="hidden flex-shrink-0 text-blue-600 sm:block" />
        </a>
      </div>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss banner"
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-gray-500 hover:text-gray-800"
      >
        <X size={18} />
      </button>
    </div>
  );
};

export default TopBanner;
